<template>
    <div class="dropdown px-1">
        <a :id="'dropdown-menu-link-'+ index" class="btn btn-secondary dropdown-toggle" v-bind:class="{'dropdown-clear': canClear && selectedOption}" @click="dropdown()" role="button" data-toggle="dropdown" aria-expanded="false"><span>{{headingTitle}}</span></a>
        <input v-if="mode == 'date'" :id="'dropdown-date-'+ index" type="date" v-model="selectedOption"> 
        <div v-if="canClear" @click="clearClicked" class="clear-area"></div>
        <div v-if="mode == 'options'" class="dropdown-menu" :ref="'dropdown-' + index" :aria-labelledby="'dropdown-menu-link'+ index">
            <a v-for="option in options" :key="option.key" class="dropdown-item" @click="optionClick(option)">{{option.text}}</a>
        </div>     
    </div>
</template>
<script>
import { UTILS_HELPER } from "@/helpers/utils.js";

export default {
    data(){
        return{
            selectedOption: null,
        }
    },
    props:{
        index: Number,
        mode:
        {
            type: String,
            default: 'options'
        },
        options:
        {
            type: Array,
            default: () => []
        },
        title:
        {
            type: String,
            default: ""
        },
        defaultDate:
        {
            type: Date,
            default: null
        },
        defaultOption:
        {
            type: Number,
            default: null
        },
        canClear:
        {
            type: Boolean,
            default: true
        }
    },
    computed:
    {
        headingTitle: function()
        {
            var result = this.title;

            if(this.selectedOption)
            {
                result = this.mode == 'date' ? UTILS_HELPER.formatDate(this.selectedOption) : this.selectedOption.text;
            }

            return result;
        }
    },
    mounted: function()
    {
        if(this.defaultDate)
        {
            this.selectedOption = UTILS_HELPER.getISODate(this.defaultDate);
        }
        else if(this.defaultOption && this.options.length)
        {            
            this.selectedOption = this.options.find(option => option.key == this.defaultOption);
        }

        document.addEventListener('click', this.handleClickOutside);
    },
    methods:{
        clearClicked()
        {
            this.selectedOption = null;
        },
        dropdown() {
            if(this.mode == 'options')
            {
                // Note that for date clicks are handled by the input
                this.$refs['dropdown-'+this.index].classList.toggle('d-block');
            }
        },
        optionClick(option){
            this.selectedOption = option;
            this.$refs['dropdown-'+this.index].classList.remove("d-block");
        },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                if(this.$refs['dropdown-'+this.index] !== undefined)
                {
                    this.$refs['dropdown-'+this.index].classList.remove("d-block");
                }
            }
        }
    },
    watch:
    {
        selectedOption: function(val)
        {
            var option = val;
            // if it is a date, we have to guarantee the correct format
            if(this.mode == 'date' && this.selectedOption != null)
            {
                option = UTILS_HELPER.formatDate(this.selectedOption);
            }

            this.$emit('option-changed', option);
        },
        defaultOption: function(val)
        {
            this.selectedOption = val ? this.options.find(option => option.key == this.defaultOption) : null;
        }
    }  
}
</script>

<style scoped>

.clear-area
{
    position: absolute;
    right: 0;
    width: 40px;
    height: 100%;
    top: 0;
    cursor: pointer;
}

.dropdown-clear::after
{
    content: "x";
    display: contents;
    font-weight: bold;
    border: none;
}

.dropdown-toggle
{
    min-width: 125px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.in-front
{
    z-index: 999;
}

/* Here is a way to trigger the datepicker when users click on the field itself */
input[type="date"]
{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
}

/* make the native arrow invisible and stretch it over the whole field so you can click anywhere in the input field to trigger the native datepicker*/
input[type="date"]::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    color: transparent;
    background: transparent;
    cursor: pointer;
}

</style>